import type { FaireProductEntity } from "../../entity_types/product";

export const p_upbspqmj2w: FaireProductEntity = {
  token: "p_upbspqmj2w",
  type: "product",
  name: "AAAA Grade Uruguay Amethyst Tower | Deep Purple Natural Crystal Generator",
  brandToken: "b_9c6sy2bfcu",
  brandName: "Moon Rituals",
  imageUrl:
    "https://cdn.faire.com/fastly/da17ddd9afcaf1a9ea116a4bdd2067b2efb2d41ab79c3158e606c1090596079e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6a1673223e93d0375426d219ca8a83b8f0d0060290cb144dc2198d580a4a733.jpeg",
    "https://cdn.faire.com/fastly/4439abda4969ca3636680786f9462fb910ac02f5d257128dd1cf8f42e2523c00.jpeg",
    "https://cdn.faire.com/fastly/d9d18559e201122c45049d4741625fba139dbb23e2ec8710c4ce14f98eb55f03.jpeg",
  ],
  priceDollars: 16,
  description:
    "The Uruguay Natural Amethyst Tower is a must-have for anyone looking to enhance their spiritual practice. This powerful crystal promotes spiritual awareness and emotional support, making it perfect for those seeking a deeper connection with their higher self.\n\nEach tower is hand-selected from Uruguay, where the Amethyst is known for its high quality and deep color. The unique shape and deep purple hue make it a beautiful addition to any home or office.\n\nAmethyst is a stone of peace, tranquility, and protection. It's believed to enhance intuition and psychic abilities, promote restful sleep, and help with addictive behaviors. The tower shape of this crystal is thought to amplify the energy of the stone, making it an even more powerful tool for meditation and energy work.\n\nEach tower is unique and will vary slightly in size and color.\n",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:23.555Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
